var map = {
	"./en/0/0-5/table.png": 64498,
	"./fi/0/0-5/table.png": 75728,
	"./in/0/0-5/table.png": 28502,
	"./th/0/0-5/table.png": 53647,
	"./tw/0/0-5/table.png": 14556,
	"./zh/0/0-5/table.png": 63477
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39760;